import {
  Collection,
  CollectionListResource,
  CollectionListResourceCollections,
  ProductPageResource,
} from "@/api/generated-api";
import ApiClient from "../ampm-world";
import { formattedCollections } from "./adapter";

export class ApiCollections {
  static async getCollections(lang: string): Promise<CollectionListResourceCollections[]> {
    const data = await ApiClient.get<CollectionListResource>(`/${lang}/collections`);
    return formattedCollections(data);
  }

  static async getCollection(id: number, lang: string): Promise<Collection> {
    return ApiClient.get(`/${lang}/collection/${id}`);
  }

  static async getCollectionsPage(lang: string): Promise<ProductPageResource> {
    return ApiClient.get(`/${lang}/page/collection`);
  }
}
